/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const AuditReportsOlafMissingSegmentsDtoTypeEnum = {
    MISSING_SEGMENTS: "MISSING_SEGMENTS"
} as const;

export type AuditReportsOlafMissingSegmentsDtoTypeEnumKey = (typeof AuditReportsOlafMissingSegmentsDtoTypeEnum)[keyof typeof AuditReportsOlafMissingSegmentsDtoTypeEnum];

export type AuditReportsOlafMissingSegmentsDto = {
    /**
     * @type string
    */
    type: AuditReportsOlafMissingSegmentsDtoTypeEnumKey;
    /**
     * @type string
    */
    datetime: string;
};